import React, { createContext, useContext, useState, useEffect } from "react";
import { lightThemeTokens, darkThemeTokens } from "../theme/themeConfig";

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  // 1. Önce localStorage'da tema var mı bakıyoruz
  const getInitialTheme = () => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme === "dark") return true;
    if (savedTheme === "light") return false;
    // yoksa sistem temasına bakıyoruz
    const prefersDark = window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches;
    return prefersDark;
  };

  const [isDark, setIsDark] = useState(() => {
    const dark = getInitialTheme();
    // İlk yüklemede body class'ını ayarla
    if (dark) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
    return dark;
  });
  const [themeTokens, setThemeTokens] = useState(isDark ? darkThemeTokens : lightThemeTokens);

  // 2. isDark değiştiğinde localStorage'a kaydet ve tema tokenlarını güncelle
  useEffect(() => {
    localStorage.setItem("theme", isDark ? "dark" : "light");
    setThemeTokens(isDark ? darkThemeTokens : lightThemeTokens);
    // Body'ye dark class ekle/kaldır (CSS için)
    if (isDark) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  }, [isDark]);

  // 3. Tema değiştirme fonksiyonu
  const toggleTheme = () => setIsDark((prev) => !prev);

  // 4. setThemeTokens setter'ını da context'e ekliyoruz
  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme, themeTokens, setThemeTokens }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useThemeContext = () => useContext(ThemeContext);
